"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequiredTagComponent = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var RequiredTagComponent = function (_a) {
    var _b = _a.color, color = _b === void 0 ? "text-red-600" : _b, _c = _a.size, size = _c === void 0 ? "base" : _c;
    return (0, jsx_runtime_1.jsx)("span", { className: "text-".concat(size, " ").concat(color), children: "*" });
};
exports.RequiredTagComponent = RequiredTagComponent;
